<template>
  <Popup
    :id="instanceId"
    module-name="BannerPopup"
    class="banner-popup"
    data-module="banner-popup"
    :show-on-desk="showOnDesk"
    :show-on-mobile="showOnMobile"
  >
    <EditorLink :model="linkUrl">
      <LImage
        :src="image"
        :alt="imageAlt"
      />
    </EditorLink>
  </Popup>
</template>

<script>
import Popup from '../generic/modals/Popup.vue';
import EditorLink from '../EditorLink.vue';

export default {
  name: 'BannerPopup',
  components: {
    Popup,
    EditorLink,
  },
  inheritAttrs: false,
  props: {
    ...Popup.props,
    instanceId: {
      type: String,
      default: '',
    },
    imageDesk: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
      default: '',
    },
    imageDeskAlt: {
      type: String,
      default: '',
    },
    imageMobileAlt: {
      type: String,
      default: '',
    },
    useDifferentMobileBgImage: {
      type: Boolean,
      default: false,
    },
    linkUrl: {
      type: Object,
      default: () => ({
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      }),
    },
  },
  data() {
    return {
      isDesktop: true,
    };
  },
  computed: {
    image() {
      if (this.isDesktop || !this.useDifferentMobileBgImage) {
        return this.imageDesk;
      }
      return this.imageMobile;
    },
    imageAlt() {
      if (
        this.isDesktop ||
        !this.useDifferentMobileBgImage ||
        !this.imageMobileAlt
      ) {
        return this.imageDeskAlt;
      }
      return this.imageMobileAlt;
    },
  },
  mounted() {
    this.isDesktop = window.matchMedia('(min-width: 900px)').matches;
    window.addEventListener('resize', () => {
      this.isDesktop = window.matchMedia('(min-width: 900px)').matches;
    });
  },
  metadata: {
    extends: Popup.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'image',
            label: 'Imagem',
            after: 'trigger',
            fields: [
              {
                name: 'imageDesk',
                type: 'ImageFile',
                label: 'Imagem',
                helpText: 'Dimensões recomendadas: 720x630',
              },
              {
                name: 'imageDeskAlt',
                type: 'ShortText',
                label: 'Texto alternativo para a imagem',
              },
              {
                name: 'useDifferentMobileBgImage',
                type: 'Checkbox',
                label: 'Usar uma imagem diferente para mobile',
              },
              {
                name: 'imageMobile',
                type: 'ImageFile',
                label: 'Imagem (mobile)',
                helpText: 'Dimensões recomendadas: 380x620',
                isEnabled({ useDifferentMobileBgImage }) {
                  return useDifferentMobileBgImage;
                },
              },
              {
                name: 'imageMobileAlt',
                type: 'ShortText',
                label: 'Texto alternativo para a imagem mobile',
                isEnabled({ useDifferentMobileBgImage }) {
                  return useDifferentMobileBgImage;
                },
              },
              {
                name: 'linkUrl',
                type: 'Url',
                label: 'Link/URL (opcional)',
              },
            ],
          },
        ],
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.banner-popup {
  position: absolute; // must be absolute to cover the whole EditableInstance

  &::v-deep .popup__wrapper {
    position: relative;
    width: auto;
    max-width: calc(100% - 20px);
    height: auto;
    max-height: calc(
      100% - 20px
    ); // 100% is only on Editor. Site should be 100vh
    overflow: auto;
  }

  .img {
    display: block;
  }
}
</style>
